import { authContext } from 'contexts/'
import { useProvideAuth } from 'hooks/use-provide-auth'
import { IProvideAuthProps } from './provide-auth-props.interface'

export const ProvideAuth: React.FC<IProvideAuthProps> = ({ children }) => {
  const auth = useProvideAuth()
  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}
